import type { ActiveSession } from '@/hooks/useActiveSessionTimer';

/**
 * Whether the viewer has a session that is happening or about to: `active` or `upcoming`.
 *
 * ## Invariants:
 * - `expired` is NOT live. A parker whose only session has ended gets the Center items back
 *   (PB-9032 AC4).
 * - Pure over the `sessions` the layout already has from `useActiveSessionTimer`; it never calls
 *   the timer itself, so there is no second 60 s ticker. A signed-out visitor is passed `[]`.
 */
export function useHasLiveSession(sessions: Pick<ActiveSession, 'sessionState'>[]): boolean {
  return sessions.some(
    (session) => session.sessionState === 'active' || session.sessionState === 'upcoming'
  );
}
